const commonValues = ['button', 'bg']

export const commonBeforeParseMethod = (target, common = commonValues) => {
  if (common.includes('button')) {
    const hasButton = target.button && typeof target.button === 'object'
    if (hasButton) {
      if (target.button && !target.buttons) Object.assign(target, { 
        buttons: [
          { 
            ...target.button,
            'background-color': target['button-color'],
            'border-radius': target['button-border-radius'],
            'color': target['text-button-color'],
          }
        ] 
      })
    }
  }

  if (common.includes('bg')) {
    if (target['background-type']) {
      Object.assign(target, {
        bg: {
          ...(target.bg || {}), 
          'background-type': target['background-type'],
          'background-image': target['background-image'],
          'background-video': target['background-video'],
          'background-color': target['background-color'],
          'height': target['height'],
        }
      })
    }
  }
}